import { render, staticRenderFns } from "./item.list.vue?vue&type=template&id=7ed44049&scoped=true&"
import script from "./item.list.vue?vue&type=script&lang=js&"
export * from "./item.list.vue?vue&type=script&lang=js&"
import style0 from "./item.list.vue?vue&type=style&index=0&id=7ed44049&prod&scoped=true&lang=css&"
import style1 from "./item.list.vue?vue&type=style&index=1&id=7ed44049&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed44049",
  null
  
)

export default component.exports